module.exports = "/_next/static/images/plant3-69aec7a2d69b73c6e005aae1ea5a541a.png";